
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class WorkflowSection extends Vue {
  @Prop({ default: null }) readonly pressedNextCtaIndex!: number | null;
}
